export default (status) => {
    let statuses = {
        "-3": "Отмена админом/оператором",
        "-2": "Отмена по таймеру",
        "-1": "Ручная отмена пользователем",
        "0": "Заявка создана",
        "1": "Начало",
        "2": "Получение курса",
        "3": "Получение реквизитов",
        "4": "Ожидание реквизитов вручную",
        "5": "Создание заказа",
        "10": "Завершение операции"
    };

    return statuses[String(status)] || "Неизвестный статус";
}
